import React from 'react'
import ProductSelect from '../UI/productSelect'
import * as styles from './services.module.css'

const Services = () => {
  return (
    <section id="services">
      <div className={styles.services}>
        <h2>Наши Услуги</h2>
        <span className={styles.servicesDesc}>
          Мы создаем веб-сайты любой сложности, от простых посадочных страниц до
          онлайн магазинов. Лишь одно остается неизменным: качество нашей работы
          и внимание к деталям.
        </span>
        <ProductSelect />
      </div>
    </section>
  )
}

export default Services
